import { React, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';

import CveDocument from './CveDocument/CveDocument';
import MitreAttackDoc from './MitreAttack/MitreAttackDoc';
import './DocList/DocCard.scss';
import { getDoc, getDocMeta, postDocsByIds, searchDoc } from '../services';
import { useSelector } from 'react-redux';
import { selectAuthProfiles } from '../redux/selectors/authSelectors';

const DocView = (props) => {
  const profiles = useSelector(selectAuthProfiles);
  const { repositoryId, documentId } = useParams();
  const [contents, setContents] = useState();
  const [contentsState, setContentsState] = useState(0);
  const [docType, setDocType] = useState(null);

  const isMitreDoc = (type) => {
    const validTypes = [
      'x-mitre-tactic',
      'attack-pattern',
      'course-of-action',
      'intrusion-set',
      'malware',
      'tool',
      'x-mitre-data-source',
      'x-mitre-data-component',
      'relationship',
      'identity',
      'marking-definition',
      'x-mitre-matrix',
    ];
    if (validTypes.indexOf(type) > -1) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    searchDoc(repositoryId, documentId).then((res) => {
      if (res.status === 200) {
        if (res.objectType === 'article') {
          setDocType('article');
          getDoc(documentId, repositoryId).then((res) => {
            //getDoc(repositoryId, documentId).then((res) => {
            if (res.status === 200) {
              setContents(parse(res));
              setContentsState(2);
            } else {
              setContentsState(2);
            }
          });
        } else if (res.objectType === 'vulnerability') {
          postDocsByIds(profiles.cve, [documentId]).then((res) => {
            if (res && res.documents && res.documents[0]) {
              setDocType('cve');
              setContents(res.documents[0]);
            }
          });
        } else if (isMitreDoc(res.objectType)) {
          setDocType('mitre');
          setContents(res.id);
        }
      }
    });
  }, [documentId, repositoryId]);

  return (
    <Container className='mt-4 doc-view-container'>
      <Row>
        <Col lg={12} className='mt-4 slack_channel_wrap'>
          {docType === 'article' && contents ? (
            <div className='doc-view'>
              <div className='ctx-template'>{contents}</div>
            </div>
          ) : docType === 'cve' && contents && profiles.cve ? (
            <CveDocument
              cve={contents}
              profileId={profiles.cve}
              hideId={false}
            />
          ) : docType === 'mitre' && contents && profiles.mitre ? (
            <MitreAttackDoc doc={contents} profilePrimary={profiles.mitre} />
          ) : null}
        </Col>
      </Row>
    </Container>
  );
};
export default DocView;
